import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import List from "../../purchase/material/List";
import {
  LicenseTypes,
  MapPageFor,
  MaterialRequestStatus,
  Operation,
  PageFor,
  PageFrom,
  PriorityEnum,
} from "../../../../../utils/Enum.types";
import MaterialIndex from "../../purchase/material/Index";
import ViewPendingStatus from "../../purchase/material/pending/ViewPendingStatus";
import SubsidiaryIndex from "./Index";
import AssetSiteList from "./assetsite/List";
import ItemOBList from "../../../asset/item/item_ob/List";
import ItemIndividualList from "../../../asset/item/item_individual/List";
import MapsIndex from "../../maps/MapsIndex";
import TicketsRaisedList from "../../maps/ticketdetails/TicketsRaisedList";
import JunctionRoutes from "./junctions/JunctionRoutes";
import TicketRaisedListIndex from "../../maps/ticketdetails/TicketRaisedListIndex";
import Items from "../items/Index";
import { TicketStatus } from "../../../../../utils/constants";
import DashBoardIndex from "../../DashBoardMapsView/DashboardIndex";
import ReportsIndex from "../../reports/assetwise/ReportsIndex";
const SubsidiaryRoutes = () => {
  const [modalFlag, setModalFlag] = useState(false);

  return (
    <Routes>
      <Route path="/" element={<SubsidiaryIndex />} />

      <Route
        path="/:subId/*"
        element={
          <Routes>
            <Route
              path="/assetsite"
              element={
                <AssetSiteList
                  operation={Operation.CREATE}
                  setModalFlag={setModalFlag}
                />
              }
            />
            <Route
              path="/site/:siteId/*"
              element={
                <Routes>
                  <Route
                    path="/ticketing/"
                    element={
                      <DashBoardIndex
                        NavType={LicenseTypes.COMPANY}
                        pageFor={MapPageFor.TICKET}
                      />
                    }
                  />
                  <Route
                    path="/assetsummary/:itemId"
                    element={<ReportsIndex pageFrom={PageFrom.SITE} />}
                  />
                  <Route path="/junctions/*" element={<JunctionRoutes />} />
                </Routes>
              }
            />
            <Route
              path="/material/*"
              element={
                <Routes>
                  <Route
                    path="/request"
                    element={<List pageType={MaterialRequestStatus.APPROVED} />}
                  />
                  <Route path="/add" element={<MaterialIndex />} />
                  <Route path="/:mrf_id/edit" element={<MaterialIndex />} />
                  <Route
                    path="/pending/:mrf_id/view"
                    element={
                      <ViewPendingStatus
                        pageType={PageFor.GENERAL}
                        type={MaterialRequestStatus.PENDING}
                        setModalFlag={setModalFlag}
                      />
                    }
                  />
                </Routes>
              }
            />

            <Route
              path="/item/*"
              element={
                <Routes>
                  <Route
                    path="/list"
                    element={
                      <Items
                        setModalFlag={setModalFlag}
                        pageType={PageFor.GENERAL}
                      />
                    }
                  />
                  <Route
                    path="ob/list"
                    element={<ItemOBList NavType={LicenseTypes.SUBSIDIARY} />}
                  />
                  <Route
                    path="individual/list"
                    element={
                      <ItemIndividualList NavType={LicenseTypes.SUBSIDIARY} />
                    }
                  />
                </Routes>
              }
            />
            <Route
              path="/maps"
              element={
                <MapsIndex
                  NavType={LicenseTypes.SUBSIDIARY}
                  pageFor={MapPageFor.VIEW}
                />
              }
            />
            <Route
              path="/ticketing"
              element={
                <DashBoardIndex
                  NavType={LicenseTypes.SUBSIDIARY}
                  pageFor={MapPageFor.TICKET}
                />
              }
            />
            <Route
              path="/raisedticketdetails"
              element={
                <TicketRaisedListIndex
                  NavType={LicenseTypes.SUBSIDIARY}
                  pageFor={MapPageFor.TICKET}
                  ticketStatusType={TicketStatus.ALL}
                  setModalFlag={setModalFlag}
                  ticketPriority={PriorityEnum.ALL}
                />
              }
            />
            <Route
              path="/assets"
              element={
                <TicketsRaisedList
                  NavType={LicenseTypes.SUBSIDIARY}
                  pageFor={MapPageFor.VIEW}
                  ticketStatusType={TicketStatus.ALL}
                  setModalFlag={setModalFlag}
                  ticketPriority={PriorityEnum.ALL}
                />
              }
            />
          </Routes>
        }
      />
    </Routes>
  );
};

export default SubsidiaryRoutes;
